import PageLoader from '@/helpers/PageLoader';

import { PageMappingCasino } from '@/helpers/PageMappingHelpers';

const CS_PATH_CASINO_PRODUIT = [
  PageMappingCasino.CASINO_PRODUIT.siteUrl,
  PageMappingCasino.CASINO_PRODUIT.siteUrlEn,
];
const CS_PATH_CASINO_COLLECTION = [
  PageMappingCasino.CASINO_COLLECTION.siteUrl,
  PageMappingCasino.CASINO_COLLECTION.siteUrlEn,
];

// TODO: Traiter Casino en direct via un éventuel catalogue CED (vs produitCasino)
const routesCasino = [
  // Pour éviter ce warning on doit débuter par un slash:
  // on-nested routes must include a leading slash character. Fix the following routes:
  {
    // param1: idFamille (CED) ou idProduit (Casino)
    // param2: toujours idProduit
    path: `/(${CS_PATH_CASINO_PRODUIT.map((s) => s.slice(1)).join(
      '|'
    )})/:idCategorie/:param1/:param2?`,
    component: PageLoader,
    props: {
      windowLocationPathname: CS_PATH_CASINO_PRODUIT[0],
    },
  },
  {
    path: `/(${CS_PATH_CASINO_COLLECTION.map((s) => s.slice(1)).join('|')})/:idProduitCollection`,
    component: PageLoader,
    props: {
      windowLocationPathname: CS_PATH_CASINO_COLLECTION[0],
    },
  },
];

export default routesCasino;
